var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { invariant } from "@madmedical/utils";
import PreOpSurveyRow from "../../../molecules/PreOpSurveyRow";
import { usePreOp } from "../../../providers/preop";
const PreOpResultRow = (_a) => {
    var _b;
    var { questionkey } = _a, rest = __rest(_a, ["questionkey"]);
    const { questionnaire } = usePreOp();
    invariant(questionnaire);
    return (_jsx(PreOpSurveyRow, Object.assign({ isReadOnly: true, name: questionkey, isYes: (_b = questionnaire.answers[questionkey]) !== null && _b !== void 0 ? _b : false, answer: questionnaire.subAnswers[questionkey] }, rest)));
};
export default PreOpResultRow;
